/**
 * Helpers partagés — thème FONCTIONS 3ème (attendus 221-230, d13).
 *
 * Conventions : expressions rendues en KaTeX (FORMATS_TANOED §0.5bis) via des
 * FRAGMENTS LaTeX composables, décimaux FR sans zéro final, tableaux HTML de
 * valeurs, noms de fonctions f/g/h/k tirés. Les réponses TAPÉES restent en
 * texte brut (« -3/4 », « 4,6 »).
 */

export const pgcd = (a, b) => { a = Math.abs(a); b = Math.abs(b); while (b) { [a, b] = [b, a % b]; } return a || 1; };
export const rat = (p, q = 1) => { if (q < 0) { p = -p; q = -q; } const g = pgcd(p, q); return { p: p / g, q: q / g }; };

/** Écriture ASCII d'un rationnel — pour les réponses SAISIES uniquement. */
export const fmtRat = (r) => (r.q === 1 ? String(r.p) : `${r.p}/${r.q}`);

/** Fragment LaTeX d'un rationnel, signe devant la barre — pour l'AFFICHAGE. */
export const ratFrag = (r) => (r.q === 1
    ? String(r.p)
    : `${r.p < 0 ? '-' : ''}\\dfrac{${Math.abs(r.p)}}{${r.q}}`);

/** Décimal FR sans zéro final : 4.6 → « 4,6 » ; -0.25 → « -0,25 ». */
export const frNb = (x) => String(Math.round(x * 1000) / 1000).replace('.', ',');

/**
 * Décimal FR en LaTeX : « 4,6 » → « 4{,}6 » (sinon KaTeX espace la virgule).
 * Accepte un NOMBRE ou une chaîne DÉJÀ formatée à la française — passer
 * « 1,6 » à frNb donnerait NaN (bug réel attrapé par le check S-ABERRANT).
 */
export const decFrag = (x) =>
    (typeof x === 'number' ? frNb(x) : String(x)).replace(',', '{,}');

/**
 * Moins typographique — réservé à la PROSE. Dans un fragment LaTeX, le `-`
 * ASCII suffit : KaTeX le rend déjà comme un vrai signe moins.
 */
export const MOINS = '−';

/** Fragment LaTeX « ax + b » (coefficients 1 et −1 cachés devant la lettre). */
export const fmtAffine = (a, b) => {
    const ax = a === 0 ? '' : (a === 1 ? 'x' : (a === -1 ? '-x' : `${decFrag(a)}x`));
    if (b === 0) return ax || '0';
    const bAff = b < 0 ? `- ${decFrag(-b)}` : `+ ${decFrag(b)}`;
    return ax ? `${ax} ${bAff}` : decFrag(b);
};

const T_TH = 'background:#1E3A8A;color:#fff;padding:5px 10px;border:1px solid #64748b;font-weight:600';
const T_TD = 'padding:5px 10px;border:1px solid #64748b;text-align:center';

/** Tableau HTML « x / nom(x) » ; cells peuvent contenir « ? ». */
export const tableFn = (nom, xs, ys) => `<table style="border-collapse:collapse;margin:12px auto">`
    + `<tr><th style="${T_TH}">x</th>${xs.map(x => `<td style="${T_TD}">${x}</td>`).join('')}</tr>`
    + `<tr><th style="${T_TH}">${nom}(x)</th>${ys.map(y => `<td style="${T_TD}">${y}</td>`).join('')}</tr></table>`;

export const NOMS_FN = ['f', 'g', 'h', 'k'];
